import { ProductTypes } from '../../../enums/product-types.enum';

export const sectionTitles = {
  [ProductTypes.BUNDLES]: '',
  [ProductTypes.MEMBERSHIPS]: '',
  [ProductTypes.ORCHESTRAS]: 'Other offers'
};

export const KEYS_TO_SHOW = [
  ProductTypes.MEMBERSHIPS,
  ProductTypes.BUNDLES,
  ProductTypes.ORCHESTRAS
];